import React from "react"; // eslint-disable-line no-unused-vars

import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

import DocContextMenuElement from "./DocContextMenuElement";
import update from "immutability-helper";

class DocsContextMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doctors: props.doctors,
    };
  }

  componentWillReceiveProps(nextProps) {
    //this.setState({ doctors: nextProps.doctors });

    let sortedDocs = this.props.getSortedDocs.sortedDocs.sortedDocs;
    if (sortedDocs.length !== nextProps.doctors.length) {
      this.setState({ doctors: nextProps.doctors });
      sortedDocs = this.state.doctors.map((d) => d.id);
    } else {
      let fullSortedDocs = [];
      sortedDocs.forEach((id) => {
        fullSortedDocs.push(nextProps.doctors.find((d) => d.id === id));
      });
      this.setState({ doctors: fullSortedDocs });
    }
  }

  saveNewOrder = async () => {
    const sortedDocs = this.state.doctors.map(({ id, name }, index) => {
      return id; //{ doctorId: id, index };
    });
    try {
      await this.props.updateSortedDocs({
        variables: {
          sortedDocs,
        },
      });
    } catch (e) {
      console.error("update local state", e);
    }
    this.props.toggleDropdown();
  };

  moveDoc = (dragIndex, hoverIndex) => {
    const { doctors } = this.state;
    const dragDoc = doctors[dragIndex];

    this.setState(
      update(this.state, {
        doctors: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragDoc],
          ],
        },
      })
    );
  };

  render() {
    return (
      <div className="dropdown-menu" id="dropdown-menu" role="menu">
        <div className="dropdown-content">
          {
            <a
              className={`dropdown-item ${
                this.props.selectedDoctorId === null ? " is-active" : ""
              }`}
              key="0"
              onClick={() => this.props.handleChangeDoc(null)}
            >
              Tous
            </a>
          }

          {
            /*sortedDocs.map((id, i) => {
            const doc = this.state.doctors.find((d) => d.id === id);
*/
            this.state.doctors.map((doc, i) => {
              return (
                <DocContextMenuElement
                  key={doc.id}
                  id={doc.id}
                  index={i}
                  moveDoc={this.moveDoc}
                  saveNewOrder={this.saveNewOrder}
                  handleChangeDoc={this.props.handleChangeDoc}
                  doc={doc}
                  selectedDoctorId={this.props.selectedDoctorId}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
}

const UPDATE_SORTEDDOCS = gql`
  mutation updateSortedDocs($sortedDocs: String) {
    updateSortedDocs(sortedDocs: $sortedDocs) @client
  }
`;
const GET_SORTEDDOCS = gql`
  query {
    sortedDocs @client {
      sortedDocs
    }
  }
`;

export default compose(
  graphql(UPDATE_SORTEDDOCS, {
    name: "updateSortedDocs",
  }),
  graphql(GET_SORTEDDOCS, {
    name: "getSortedDocs",
    options: { fetchPolicy: "cache-only" },
  })
)(DocsContextMenu);



// WEBPACK FOOTER //
// ./src/components/utilities/DocsContextMenu.js